import React, { forwardRef } from "react";
import { Typeahead, TypeaheadHandle } from "./base";
import { ProductApi } from "@/api/ProductsApi";

type ProductCodeTypeaheadProps = {
  setFormData: (field: string, value: any) => void;
  searchProduct: (productCode: string) => void;
  loadProduct: React.KeyboardEventHandler<HTMLInputElement>;
  /** ref opcional al <input> interno, distinto del ref del TypeaheadHandle */
  inputRef?: React.Ref<HTMLInputElement>;
};

/**
 * forwardRef expone el ref de TypeaheadHandle (clear, focus, setValue)
 */
const ProductCodeTypeahead = forwardRef<TypeaheadHandle, ProductCodeTypeaheadProps>(
  ({ setFormData, loadProduct, searchProduct, inputRef }, ref) => {
    async function fetchProductSuggestions(q: string) {
      const { items } = await ProductApi.searchByProductByCode(q, ["id", "codigo"], 10);
      return items?.map(p => ({ id: String(p.id), codigo: String(p.codigo) })) ?? [];
    }

    return (
      <Typeahead
        ref={ref}
        placeholder="Código de producto…"
        minChars={1}
        debounceMs={200}
        fetchSuggestions={fetchProductSuggestions}
        onSelect={(item) => {
          setFormData("codigo", item.codigo);
          searchProduct(item.codigo);
        }}
        inputRef={inputRef}
        onInputChange={(e) => setFormData("codigo", e.target.value)}
        onInputKeyDown={loadProduct}
      />
    );
  }
);

ProductCodeTypeahead.displayName = "ProductCodeTypeahead";

export default ProductCodeTypeahead;